import { useMemo } from "react";
import { useDispatch } from "react-redux";
import MenuRoot from "../../../components/Menu";
import { usePlan } from "../../../contexts/PlanOperationContext/Plan";
import { selectOverview } from "../../../util/store/selectors";
import { getStore } from "../../../util/store/store";
import { ACTION_TYPE, AVAILABLE_TIME_TYPE, CERTAIN_TYPE, OP_STATUS, OPERATION_TYPE, TIME_PER_STEP } from "../../../util/varibles/constants";
import { IPropsChildren, IVessel } from "../../../util/varibles/interface";
import { EL_RULE } from "../../PlanOperationPage/Plan/Calendar/constants";
import { canEditOperationInPast, MENU_CALENDAR, menuOp } from "../../PlanOperationPage/_components/Menu/options";
import { openEdit } from "../Popup/PopupEdit";
import { menuOptions } from "./constants";

interface IProps extends IPropsChildren {
    vessel: IVessel;
}

const Menu: React.FC<IProps> = ({ vessel, children }) => {
    const [target] = usePlan(state => state.target);
    const dispatch = useDispatch();

    const menu = useMemo(() => {
        let list: any[] = [];
        if (!vessel || !target)
            return [];

        const { type } = target;
        switch (type) {
            case EL_RULE.VESSEL: {
                const { time } = target;
                const { isOwn, permission: vesselPermission, available_time_type } = vessel;
                if (isOwn || vesselPermission || available_time_type === AVAILABLE_TIME_TYPE.ALL) {
                    const start = Math.round(time / TIME_PER_STEP) * TIME_PER_STEP;
                    list.push({
                        key: MENU_CALENDAR.ADD_EVENT,
                        label: <div>Add event</div>,
                        onClick: () => openEdit({
                            editMode: ACTION_TYPE.CREATE, data: {
                                operation: {
                                    operation_type: OPERATION_TYPE.EVENT,
                                    note: "",
                                    certain_mode: CERTAIN_TYPE.NONE,
                                    pois: [],
                                    checklist_ids: [],
                                } as any,
                                activity_log: [{ est_start_time: start }, { est_start_time: null }] as any,
                                vessel
                            }
                        }),
                    })
                }
                break;
            }
            case EL_RULE.OPERATION: {
                const { data, edit } = target;
                const { status, operation_type } = data.operation;

                const start = data.activity_log[0].est_start_time;
                let isActive = false;
                if (operation_type === OPERATION_TYPE.SERVICE) {
                    isActive = status !== OP_STATUS.FINISHED
                } else {
                    isActive = status !== OP_STATUS.PROCESSING
                        && status !== OP_STATUS.FINISHED
                        && (start > Date.now() || canEditOperationInPast(data));
                }

                const common = {
                    dispatch,
                    operations: selectOverview.ops(getStore()),
                    edit: () => {
                        const { editMode } = edit();
                        openEdit({ editMode, data })
                    }
                }
                list = menuOptions[operation_type]?.map(type => menuOp[type]({ ...data, isActive }, common)) || [];
                break;
            }

        }
        return list.filter(item => item);
    }, [dispatch, target, vessel])

    return <MenuRoot
        items={menu}
        visible={menu.length === 0 ? false : undefined}
        trigger={['contextMenu']}
        className="min-w-0"
    >
        <div className="flex relative min-w-0 w-full">
            {children}
        </div>
    </MenuRoot>
}

export default Menu;
